import React from "react";
import moment from "moment";

const AnalyticsTableData = ({ tableData, index }) => {
  const getStatusColor = (status) => {
    if (status === "pending") {
      return "Medium_Purple";
    }
    return orderStatus?.find((e) => e?.status === status)?.color;
  };

  return (
    <tr className="table-rows1">
      <td className="table-each-row-data">{index + 1}</td>
      <td className="table-each-row-data">
        {tableData?.order_id ? tableData?.order_id : "--"}
      </td>
      <td className="table-each-row-data text-capitalize">
        {tableData?.orderHeirarchy?.user_type === "doctor"
          ? tableData?.doctor?.name
          : tableData?.pharmacy?.pharmacy_name}
      </td>
      <td className="table-each-row-data">
        {tableData?.createdAt
          ? moment(tableData?.createdAt).format("DD MMM YYYY, HH:mm A")
          : "--"}
      </td>
      <td className="table-each-row-data">
        {tableData?.total ? `₹ ${tableData?.total}` : "-"}
      </td>
      <td className="table-each-row-data table-each-row-data-color-green text-capitalize">
        <span className={`${getStatusColor(tableData?.status)}`}>
          {tableData?.status ? tableData?.status : "--"}
        </span>
      </td>
    </tr>
  );
};

export default AnalyticsTableData;

export const orderStatus = [
  { status: "acknowledged", value: "Acknowledged", color: "ack_status " },
  {
    status: "partially_acknowledged",
    value: "Partially Acknowledged",
    color: "color_2ad3e7 ",
  },
  { status: "fully_invoiced", value: "Invoiced", color: "text_green" },
  {
    status: "partially_invoiced",
    value: "Partial Invoiced",
    color: "Medium_Purple",
  },
  { status: "pending", value: "Approval Pending", color: "Medium_Purple" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "rejected", value: "Rejected", color: "text-danger" },
];
